var _path, _path2, _g, _path3, _g2, _path4, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 166,
    viewBox: "0 0 644 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.41 61.51C172.41 59.98 171.59 59.26 170.16 59.26H166.08V48.23H177.62C182.42 48.23 184.15 50.37 184.15 53.23V55.27H184.35C184.35 55.27 188.74 47 200.89 47C214.98 47 224.07 58.13 224.07 74.26C224.07 90.8 213.86 101.52 200.18 101.52C189.87 101.52 185.27 94.68 185.27 94.68H185.07C185.07 94.68 185.27 96.52 185.27 99.17V120.71H172.4V61.51H172.41ZM197.84 90.61C204.99 90.61 211.01 84.79 211.01 74.48C211.01 64.58 205.7 58.14 198.04 58.14C191.3 58.14 184.97 63.04 184.97 74.58C184.97 82.64 189.26 90.61 197.84 90.61ZM235.82 61.51C235.82 59.98 235 59.26 233.57 59.26H229.49V48.23H241.33C245.93 48.23 248.27 50.17 248.27 54.56V57.62C248.27 59.56 248.07 60.89 248.07 60.89H248.27C250.62 53.44 256.85 47.51 264.81 47.51C265.93 47.51 267.16 47.71 267.16 47.71V60.48C267.16 60.48 265.83 60.27 264 60.27C258.49 60.27 252.16 63.44 249.81 71.2C249.1 73.75 248.69 76.61 248.69 79.68V100.31H235.83V61.51H235.82ZM299.23 47.01C315.16 47.01 327.82 58.34 327.82 74.27C327.82 90.3 315.16 101.53 299.23 101.53C283.4 101.53 270.74 90.3 270.74 74.27C270.75 58.34 283.41 47.01 299.23 47.01ZM299.23 90.51C307.71 90.51 314.75 83.97 314.75 74.27C314.75 64.67 307.71 58.04 299.23 58.04C290.86 58.04 283.81 64.68 283.81 74.27C283.82 83.97 290.86 90.51 299.23 90.51ZM339.77 83.77C339.77 83.77 346.41 91.43 355.29 91.43C359.27 91.43 362.34 89.8 362.34 86.32C362.34 78.97 334.87 79.07 334.87 62.22C334.87 51.81 344.26 47.01 355.09 47.01C362.14 47.01 373.37 49.36 373.37 57.83V63.24H361.93V60.69C361.93 58.24 358.25 57.01 355.39 57.01C350.8 57.01 347.63 58.64 347.63 61.71C347.63 69.88 375.3 68.24 375.3 85.6C375.3 95.4 366.62 101.53 355.29 101.53C340.99 101.53 333.64 92.24 333.64 92.24L339.77 83.77ZM387.36 61.51C387.36 59.98 386.54 59.26 385.11 59.26H381.03V48.23H392.57C397.37 48.23 399.11 50.37 399.11 53.23V55.27H399.31C399.31 55.27 403.7 47 415.85 47C429.94 47 439.03 58.13 439.03 74.26C439.03 90.8 428.82 101.52 415.14 101.52C404.83 101.52 400.23 94.68 400.23 94.68H400.03C400.03 94.68 400.23 96.52 400.23 99.17V120.71H387.36V61.51ZM412.78 90.61C419.93 90.61 425.95 84.79 425.95 74.48C425.95 64.58 420.64 58.14 412.98 58.14C406.24 58.14 399.91 63.04 399.91 74.58C399.92 82.64 404.21 90.61 412.78 90.61ZM472.01 47.01C486.92 47.01 495.09 57.94 495.09 71.72C495.09 73.25 494.78 76.52 494.78 76.52H458.84C459.86 85.71 466.6 90.51 474.46 90.51C482.83 90.51 489.06 84.69 489.06 84.69L494.47 93.68C494.47 93.68 486.51 101.54 473.54 101.54C456.28 101.54 445.56 89.08 445.56 74.28C445.56 58.24 456.39 47.01 472.01 47.01ZM481.81 67.53C481.61 61.3 477.32 57.01 472.01 57.01C465.37 57.01 460.68 60.99 459.25 67.53H481.81ZM507.65 61.51C507.65 59.98 506.83 59.26 505.4 59.26H501.31V48.23H513.15C517.74 48.23 520.09 50.17 520.09 54.56V57.62C520.09 59.56 519.88 60.89 519.88 60.89H520.09C522.44 53.44 528.67 47.51 536.63 47.51C537.75 47.51 538.98 47.71 538.98 47.71V60.48C538.98 60.48 537.65 60.27 535.81 60.27C530.3 60.27 523.97 63.44 521.62 71.2C520.91 73.75 520.5 76.61 520.5 79.68V100.31H507.63V61.51H507.65ZM549.92 57.22C549.92 55.79 549.1 54.97 547.67 54.97H543.38V48.95H550.63C555.02 48.95 556.86 50.79 556.86 54.97V79.78C556.86 87.85 558.19 94.99 568.09 94.99C579.73 94.99 586.98 84.68 586.98 73.55V48.94H593.92V92.03C593.92 93.56 594.74 94.28 596.17 94.28H600.46V100.3H593.41C589.12 100.3 587.18 98.46 587.18 94.58V92.23C587.18 90.19 587.38 88.55 587.38 88.55H587.18C585.14 93.55 578.4 101.52 567.17 101.52C555.02 101.52 549.91 94.98 549.91 81.61V57.22H549.92ZM609.76 87.75C609.76 87.75 615.48 95.51 625.59 95.51C631.31 95.51 636.41 92.75 636.41 87.34C636.41 76.11 607.62 78.15 607.62 61.61C607.62 52.32 615.58 47.72 625.9 47.72C631.11 47.72 641.52 49.76 641.52 57.01V61.4H634.98V58.95C634.98 55.17 629.47 53.74 626.1 53.74C618.95 53.74 614.66 56.19 614.66 61.19C614.66 72.73 643.45 70.07 643.45 87.13C643.45 95.71 635.69 101.53 625.48 101.53C612.1 101.53 605.77 92.54 605.77 92.54L609.76 87.75Z",
    fill: "#0B318F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9013_40425",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 48,
    width: 97,
    height: 118
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.22 48.2397H16.78C7.51 48.2397 0 55.7497 0 65.0197V124.58C0 147.25 18.38 165.63 41.05 165.63H55.25C77.92 165.63 96.3 147.25 96.3 124.58V104.85C89.37 108.01 81.68 109.79 73.56 109.79H73.53C72.01 109.79 70.76 111 70.76 112.53V122.6C70.76 134.07 61.46 143.37 49.99 143.37C36.21 143.37 25.04 132.2 25.04 118.43V48.2397H17.22V48.2397Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9013_40425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-58.7 106.93L48.14 0.0898438L154.99 106.93L48.14 213.78L-58.7 106.93Z",
    fill: "url(#paint0_linear_9013_40425)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9013_40425",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 104,
    height: 105
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.76 0.169846V0.0998535H45.82C34.35 0.0998535 25.05 9.39984 25.05 20.8698V48.2398H79.52C88.79 48.2398 96.3 55.7498 96.3 65.0198V104.85C115.24 96.2099 128.41 77.1199 128.41 54.9398C128.41 24.6498 103.85 0.0898438 73.56 0.0898438C72.62 0.0898438 71.68 0.119846 70.76 0.169846Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9013_40425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-27.34 52.4697L76.72 -51.5903L180.78 52.4697L76.72 156.53L-27.34 52.4697Z",
    fill: "url(#paint1_linear_9013_40425)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9013_40425",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 48,
    width: 72,
    height: 96
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 48.2397V118.43C25.04 132.21 36.21 143.37 49.99 143.37C61.46 143.37 70.76 134.07 70.76 122.6V112.53C70.76 111.01 72.01 109.79 73.53 109.79H73.56C81.68 109.79 89.37 108.02 96.3 104.85V65.0197C96.3 55.7497 88.78 48.2397 79.52 48.2397H25.04Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9013_40425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22.53 95.7999L60.67 12.6099L143.86 95.7999L60.67 179L-22.53 95.7999Z",
    fill: "url(#paint2_linear_9013_40425)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9013_40425",
    x1: 6.70607,
    y1: 148.376,
    x2: 73.2192,
    y2: 81.8628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B318F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0B318F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    stopColor: "#0A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6921,
    stopColor: "#074DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#026EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9013_40425",
    x1: 34.2999,
    y1: 94.8884,
    x2: 115.642,
    y2: 13.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E94E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9013_40425",
    x1: -0.773784,
    y1: 157.251,
    x2: 77.9936,
    y2: 78.4837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A1002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E60012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60012"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.897f6061fc5b89220665b448ab630cd3.svg";
export { ForwardRef as ReactComponent };